import React from "react";
import { useTranslation } from "react-i18next";
import {
  CardContainer,
  CardHeader,
  IconWrapper,
  StyledPrivyIcon,
  AppIcon,
  ComingSoonBadge,
  CardTitle,
  CardDescription,
  ActivateButton,
} from "../styles/Card";

interface CardProps {
  title: string;
  icon?: string;
  description: string;
  status: number;
  onPress?: () => void;
}
type StatusKey = 1 | 2 | 3;
const statusValue: Record<StatusKey, string> = {
  1: "Disable",
  2: "soon",
  3: "Active",
};
const Card: React.FC<CardProps> = ({
  title,
  icon,
  description,
  status,
  onPress,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const isRtl = language === "ar";
  const isSoon = status == 2;
  const canActivate = status !== 3 && status !== 2;
  return (
    <CardContainer $isRtl={isRtl}>
      <CardHeader>
        <IconWrapper>
          {icon ? <AppIcon src={icon} /> : <StyledPrivyIcon />}
        </IconWrapper>
        {canActivate ? null : (
          <ComingSoonBadge onClick={isSoon ? () => {} : onPress}>
            {t(`AppMarket.${statusValue[status as StatusKey]}`)}
          </ComingSoonBadge>
        )}
      </CardHeader>

      <CardTitle onClick={isSoon ? () => {} : onPress}>{title}</CardTitle>

      <CardDescription $isRtl={isRtl}>{description}</CardDescription>
      {canActivate && (
        <ActivateButton onClick={onPress}>
          {t("AppMarket.activateNow")}
        </ActivateButton>
      )}
    </CardContainer>
  );
};

export default Card;
